import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import type { UpelaApiConfig } from '@/api/types';
import { REDACTION_SENTINEL } from '@/api/types';
import { Field, FormShell, SecretInput } from './shared';

interface Props {
  initial: UpelaApiConfig | null;
  onSubmit: (config: Partial<UpelaApiConfig>) => void;
  submitting: boolean;
  onCancel: () => void;
  onReset?: () => void;
}

export function UpelaApiForm({ initial, onSubmit, submitting, onCancel, onReset }: Props): JSX.Element {
  const { t } = useTranslation();
  const [baseUrl, setBaseUrl] = React.useState(initial?.baseUrl ?? '');
  const [username, setUsername] = React.useState(initial?.username ?? '');
  const [password, setPassword] = React.useState(initial?.password ?? '');

  return (
    <form
      id="integration-form"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({
          baseUrl: baseUrl.trim(),
          username: username.trim(),
          password: password === REDACTION_SENTINEL || !password ? REDACTION_SENTINEL : password,
        });
      }}
    >
      <FormShell submitting={submitting} onCancel={onCancel} onReset={onReset}>
        <Field label={t('integrations.form.upela-api.baseUrl')} htmlFor="apa-url" required hint={t('integrations.form.upela-api.baseUrlHint')}>
          <Input
            id="apa-url"
            value={baseUrl}
            onChange={(e) => setBaseUrl(e.target.value)}
            placeholder="https://apapi.upela.com"
            required
          />
        </Field>
        <Field label={t('integrations.form.upela-api.username')} htmlFor="apa-user" required hint={t('integrations.form.upela-api.usernameHint')}>
          <Input
            id="apa-user"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="zorro-bot"
            required
          />
        </Field>
        <Field label={t('integrations.form.upela-api.password')} htmlFor="apa-pwd" required hint={t('integrations.form.upela-api.passwordHint')}>
          <SecretInput id="apa-pwd" value={password} onChange={setPassword} />
        </Field>
      </FormShell>
    </form>
  );
}
